import {AuthService} from '../../shared/services/auth-service.service';

export abstract class OngletGestionEquipeComponent {
	loading = false;
	loginUtilisateurConnecte: string;

	constructor(private authService: AuthService) {
	}

	chargerDonnees(): void {
		this.loginUtilisateurConnecte = this.authService.getUtilisateurConnecte().login;
		this.loading = true;
		this.chargerDonneesImpl();

	}

	protected abstract chargerDonneesImpl(): void;
}
